import { useEffect } from "react";
import BreadCrumb from "../../components/BreadCrumb";

const Index = ({
    breadcrumbList,
    pageDetails,
    descriptionRef,
    isLoading
}) => {

    const scopeStyles = (html) => {
        return html.replace(/<style([^>]*)>([\s\S]*?)<\/style>/gi, (match, attr, css) => {
            // Prefix every selector inside the style tag with .full_description_text
            const scopedCss = css.replace(/(^|\})\s*([^{]+)/g, (fullMatch, brace, selector) => {
                if (selector.includes('@')) return fullMatch; // Skip @media, @keyframes
                return `${brace} .full_description_text ${selector}`;
            });
            return `<style${attr}>${scopedCss}</style>`;
        });
    };

    useEffect(() => {
        const container = descriptionRef.current;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = pageDetails?.content;
        const scriptTags = tempDiv.querySelectorAll('script');
        scriptTags.forEach((oldScript) => {
            const newScript = document.createElement('script');
            for (let attr of oldScript.attributes) {
                newScript.setAttribute(attr.name, attr.value);
            }
            newScript.text = oldScript.textContent;

            container.appendChild(newScript);
        });
    }, [pageDetails?.content]);
    return (
        <>
            <div className="container">
                <BreadCrumb list={breadcrumbList} />
            </div>

            {
                isLoading ?

                    <section className="faqs_section">
                        <div className="faqs_section_part">
                            <div className="container">
                                <div className="faqs_box">

                                    <div className="row">
                                        <div className="col-lg-8">
                                            <div className="question_box">
                                                <div className="accordion accordion-flush" id="accordionFlushExample">
                                                    <div className="accordion-item skeleton">
                                                        <h2 className="accordion-header">
                                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                                data-bs-target="#flush-collapseOne" aria-expanded="false"
                                                                aria-controls="flush-collapseOne">
                                                                Proin id ultrices vitae amet at posuere?
                                                            </button>
                                                        </h2>
                                                        <div id="flush-collapseOne" className="accordion-collapse collapse"
                                                            data-bs-parent="#accordionFlushExample">
                                                            <div className="accordion-body">

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="accordion-item skeleton">
                                                        <h2 className="accordion-header">
                                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                                data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                                                aria-controls="flush-collapseTwo">
                                                                Proin id ultrices vitae amet at posuere?
                                                            </button>
                                                        </h2>
                                                        <div id="flush-collapseTwo" className="accordion-collapse collapse"
                                                            data-bs-parent="#accordionFlushExample">
                                                            <div className="accordion-body">

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="accordion-item skeleton">
                                                        <h2 className="accordion-header">
                                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                                data-bs-target="#flush-collapseThree" aria-expanded="false"
                                                                aria-controls="flush-collapseThree">
                                                                Faucibus a etiam pharetra vele ultrices lorem?
                                                            </button>
                                                        </h2>
                                                        <div id="flush-collapseThree" className="accordion-collapse collapse"
                                                            data-bs-parent="#accordionFlushExample">
                                                            <div className="accordion-body">

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="accordion-item skeleton">
                                                        <h2 className="accordion-header">
                                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                                data-bs-target="#flush-collapseFour" aria-expanded="false"
                                                                aria-controls="flush-collapseFour">
                                                                Proin id ultrices vitae amet at posuere?
                                                            </button>
                                                        </h2>
                                                        <div id="flush-collapseFour" className="accordion-collapse collapse"
                                                            data-bs-parent="#accordionFlushExample">
                                                            <div className="accordion-body">

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="accordion-item skeleton">
                                                        <h2 className="accordion-header">
                                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                                data-bs-target="#flush-collapseFive" aria-expanded="false"
                                                                aria-controls="flush-collapseFive">
                                                                Nascetur viverra purus facilisis non faucibus?
                                                            </button>
                                                        </h2>
                                                        <div id="flush-collapseFive" className="accordion-collapse collapse"
                                                            data-bs-parent="#accordionFlushExample">
                                                            <div className="accordion-body">

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="accordion-item skeleton">
                                                        <h2 className="accordion-header">
                                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                                data-bs-target="#flush-collapseSix" aria-expanded="false"
                                                                aria-controls="flush-collapseSix">
                                                                Proin id ultrices vitae amet at posuere?
                                                            </button>
                                                        </h2>
                                                        <div id="flush-collapseSix" className="accordion-collapse collapse"
                                                            data-bs-parent="#accordionFlushExample">
                                                            <div className="accordion-body">

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="send_email backLayerCom skeleton">
                                                <h5>More questions?</h5>
                                                <span>info@toursxplorer.com</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section> :
                    <div
                        id='full_description_text_activity'
                        className="comon-tags-class"
                        ref={descriptionRef}
                        dangerouslySetInnerHTML={{ __html: pageDetails?.content ? scopeStyles(pageDetails?.content).replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '') : "" }}

                    />
            }
        </>
    )

}
export default Index;